import c from "react";
import { PinIcon as p } from "./PinIcon.js";
import { Flex as d } from "../Flex/Flex.js";
import x from "../../helpers/parsePtBrFloat.js";
import s from "./computePinDinamically.js";
const f = _ref => {
  let {
    rectColors: o,
    quartileIndex: l,
    adPrice: n,
    olxPrice: a
  } = _ref;
  const i = o.length,
    m = o.map((r, e) => ({
      color: r,
      index: e
    }));
  return c.createElement(d, {
    className: "olx-price-reference-ruler__flex",
    justifyContent: "center"
  }, m.map(_ref2 => {
    let {
      color: r,
      index: e
    } = _ref2;
    let t;
    return e === i - 1 ? t = "0px 20px 20px 0px" : e === 0 && (t = "20px 0px 0px 20px"), c.createElement("div", {
      className: "olx-price-reference-ruler__rect",
      key: "meter-graph-bar-".concat(r).concat(e),
      "data-testid": "meter-graph-bar-".concat(r),
      style: {
        "--background-color": r,
        "--border-radius": t,
        "--width": "calc(100%/".concat(i, ")")
      }
    }, l === e && a && n ? c.createElement(p, {
      className: "olx-price-reference-ruler__pin-icon--dynamic",
      "data-testid": "meter-price-pin-dynamic",
      style: {
        "--left-dynamic": "".concat(s(l, x(n), a), "%")
      }
    }) : null);
  }));
};
export { f as Ruler };